import React from 'react';
import PricePlanCard from './PricePlanCard';
import FrequentQuestion from './Frequent-Question';
import PartnerWithUs from './Partner-with-Us';
import MarketplacePlanBenefits from './Marketplace-Plan-Benefits';
import RevenueSharing from './RevenueSharing';
import RestaurantRoadmap from './RestaurantRoadmap';
import WindowSharingRevenue from './WindowSharingRevenue';

const PricePlanPage = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <div
        style={{
          color: 'orange',
          fontFamily: 'Segoe UI',
          fontSize: '20px',
          fontWeight: 'bold',
          marginTop: '10px',
        }}
      >
        Keep it healthy
      </div>
      <div
        style={{
          color: '#1B1642',
          fontSize: '55px',
          fontFamily: 'Playfair Display',
          fontWeight: 600,
        }}
      >
        Simple, fair pricing.
      </div>
      <div
        style={{
          color: '#1B1642',
          fontFamily: 'Segoe UI',
          fontSize: '20px',
          // fontWeight: 'bold',
          textAlign: 'center',
          maxWidth: '830px',
          marginBottom: '20px',
        }}
      >
        We’re the only platform that shares revenue with restaurants — creating an extra stream of
        passive income while giving you control over your local customers and keeping your
        restaurant on top of the platform
      </div>

      <PricePlanCard />

      <div style={{ marginTop: '40px' }}>
        <RevenueSharing />
      </div>

      <WindowSharingRevenue />

      <div>
        <RestaurantRoadmap />
      </div>

      {/* <div style={{ width: '1000px', marginTop: '40px' }}>
        <PartnerWithUs />
      </div>

      <div style={{ width: '1000px', marginTop: '20px' }}>
        <MarketplacePlanBenefits />
      </div>

      <div style={{ width: '1000px', marginTop: '20px' }}>
        <FrequentQuestion />
      </div> */}

      <div
        style={{
          position: 'absolute',
          top: '0px',
          left: '0px',
          width: '100%',
          // height: '110rem',
          backgroundColor: '#F6F6F6',
          zIndex: -1,
        }}
      ></div>
    </div>
  );
};

export default PricePlanPage;
